<template>
  <div class="popular-container">
    <h4 class="popular-title">Our most popular offers</h4>
    <div class="four-cards-group">
      <b-card-group deck class="deck-cards">
        <b-card
          v-for="(product) in activeCards()"
          :key="product.id"
          :title="product.productTitle"
          :img-src="product.cardImage"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius"
          id="productCard"
          ref="btnPerksShow"
          @click="updateQueryParams(product.category, product.id); idContent(product); showModalOrOpenLink(product.hasModal, product.externalUrl);"
        >

          <!-- PERK BADGE FOR FREE USERS OR NON VALID TRIAL OR CANCELED SUBS -->
          <img class="text-center card-img-overlay" v-if="shouldBehaveLikeFree" :src="product.personalBadge.freeBadge" alt="Card image"  style="width: 90%; max-height: 95px; padding: 0; background-color: transparent; top: 175px; left: 5%">

          <!-- PERK BADGE FOR PAID USERS -->
          <!-- <img class="text-center card-img-overlay" v-else :src="customerInfo.user.plan.toUpperCase().startsWith('TRIAL') || customerInfo.user.plan.toUpperCase() === 'MONTHLY' ? product.personalBadge.monthlyBadge : product.personalBadge.yearlyBadge" alt="Card image"  style="width: 90%; max-height: 95px; padding: 0; background-color: transparent; top: 175px; left: 5%"> -->
          <img class="text-center card-img-overlay" v-else :src="imageBadgePaidUsers === 'YEARLY' ? product.personalBadge.yearlyBadge : product.personalBadge.monthlyBadge " alt="Card image"  style="width: 90%; max-height: 95px; padding: 0; background-color: transparent; top: 175px; left: 5%">

          
 
          <b-card-text>
            {{ product.description }}
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>

    <!-- MODAL GENERIC -->
    <ExpoModalComponent :id="id" :perksCardsData="perksCardsData" :customerInfo="customerInfo" :customerLastSubscription="customerLastSubscription" v-if="false"/>

    <!-- BUTTON -->
    <div class="button-see-more-box" v-if="!hiddenButton">
      <b-button
        pill
        variant="outline-dark"
        class="button-see-more"
        @click="loadMore"
        >See More</b-button
      >
    </div>
  </div>
</template>

<script>
import ExpoModalComponent from '@/components/centre/expo/ExpoModalComponent.vue';

import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";


export default {
  name: "ExpoShowAllCards",
  components: {
    ExpoModalComponent,
  },
  props: ["customerInfo", "perksCardsData", "id", "customerLastSubscription", "customerSubscriptionDetails"],
  mounted() {
    if (this.$route.name === 'Perks' && this.$route.query.category) {
      this.activeCategory = this.$route.query.category;
    } else {
      this.activeCategory = 'ShowAll';
    }
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  updated() {
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  data() {
    return {
      activeCategory: 'ShowAll',
      modernCosmeticsImg: ModernCosmetics,
      length: 20, //8
      hiddenButton: false,
    };
  },
  computed: {
    imageBadgePaidUsers() {
      if (!this.shouldBehaveLikeFree) {
        if (this.customerInfo &&  this.customerInfo.plan && this.customerInfo.plan.toUpperCase() === 'TRIAL') {
          return 'MONTHLY';
        }
      }
      return this.customerLastSubscription && this.customerLastSubscription.period&& this.customerLastSubscription.period.toUpperCase() === 'YEARLY' ? 'YEARLY' : 'MONTHLY';
    },
    shouldBehaveLikeFree() {
      if(this.customerInfo && this.customerInfo.user && !this.customerInfo.user.paid) {
        if(this.activeOrCancelingSubscription) {
          return false;
        }
        else if(this.customerInfo.user.plan && this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan && this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying trial ended
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription && !this.customerLastSubscription.status) {
        return false;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
  },
  methods: {
    showModalOrOpenLink(hasModal, url) {
      if(hasModal) {
        this.$root.$emit('bv::show::modal', 'modal-perk', '#btnPerksShow');
      } else {
        if(url !== '') {
          //to open an external link instead of a modal
        window.open(url, '_blank', 'noreferrer');
        }
      }
    },
    activeCards: function() {
      this.$root.$on("category", (value) => {
        this.activeCategory = value;
        //to restart initial lenght in case the button show more was clicked
        this.length = 20; //8
      });
      if (this.activeCategory !== 'ShowAll') {
        return this.perksCardsData.filter((u) => {
          // return u.category === this.activeCategory;
          return u.category.includes(this.activeCategory);
        }).slice(0, this.length);
      }
      return this.perksCardsData.slice(0, this.length);
    },
    loadMore() {
      if (this.length > this.perksCardsData.length) return;
      this.length = this.length + 4;
    },
    updateQueryParams(category, id) {
      this.$router.push({
        name: "Expo",
        query: { category: category, id: id },
      }).catch(()=>{});
    },
    idContent(idContent) {
      this.$root.$emit(
        "id-content",
        idContent
      );
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.popular-title {
  font-weight: 700;
  margin: 3rem 0;
}

.deck-cards {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}

div.card {
  border: none;
  cursor: pointer;
  //display: inline-block;
    
  transition: all .2s ease-in-out;
    
  &:hover {
    cursor: pointer;
    transform: scale(1.04);
  }
}

.card-img-top {
  //background-color: $light-gray;
  margin-bottom: 2rem;
}

h4.card-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.add-border-radius {
  border-radius: 1rem;
  //margin-left: 0;
  //margin-right: 0;
  min-width: 209.5px;
  max-width: 209.5px;
  margin: 1rem 1.25rem;

  //object-fit: cover;

  img {
    border-radius: 1rem 1rem 0 0;
    background-color: $light-gray;
    height: 220px;
  }
}

.button-see-more-box {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  button {
    font-weight: 700;
    &:hover {
      background-color: black;
    }
  }
}

/* Row Container */
.row {
  display: flex;
  flex-wrap: wrap;
}

/* In order to create four equal columns */
.column {
  flex: 25%;
  padding: 20px;
}

/* two columns */
@media screen and (max-width: 992px) {
  .column {
    flex: 50%;
  }

  .deck-cards.card-deck {
    justify-content: center;
  }
}

/* One column */
@media screen and (max-width: 600px) {
  .row {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .card-deck {
    margin-left: 0;
  }
}

@media screen and (max-width: 575px) {
  .four-cards-group {
    margin-bottom: 0;
  }

  .card-deck {
    display: block;
    text-align: -webkit-center;
  }

  .add-border-radius {
    margin-right: 1rem;
  }
}

@media screen and (max-width: 399px) {
  .card-deck {
    text-align: -webkit-center;
  }
}
</style>
